import React from "react";
import { Flex, IconCatchBrand, Link, Span, Text } from "@catchoftheday/cg-components";
import { CATCH_SELLER_ID } from "../../../../consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var NewSellerInformation = function NewSellerInformation(_ref) {
  var _ref$shipping = _ref.shipping,
      soldByCatch = _ref$shipping.soldByCatch,
      isFBC = _ref$shipping.isFBC,
      _ref$seller = _ref.seller,
      sellerId = _ref$seller.id,
      name = _ref$seller.name,
      slug = _ref$seller.slug,
      rating = _ref$seller.rating,
      offerId = _ref.offerId,
      isGiftCard = _ref.isGiftCard;
  return ___EmotionJSX(React.Fragment, null, soldByCatch && ___EmotionJSX(Flex, {
    flex: "0 1 100%",
    mb: 4
  }, ___EmotionJSX(Text, {
    m: 0,
    fontWeight: "medium",
    "data-testid": "sold-by-title"
  }, "Sold and delivered by"), ___EmotionJSX(IconCatchBrand, {
    width: "55px",
    height: "auto",
    title: "Catch logo",
    ml: 1
  })), !isGiftCard && !soldByCatch && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
    m: 0,
    "data-testid": "sold-by-title",
    fontWeight: "medium",
    mb: 1
  }, "Sold", isFBC ? "" : " and delivered", " by:"), ___EmotionJSX(Text, {
    m: 0,
    "data-testid": "sold-by-content",
    mb: 1
  }, slug && sellerId !== CATCH_SELLER_ID ? ___EmotionJSX(Link, {
    fontWeight: "medium",
    textDecoration: "underline",
    href: "/seller/".concat(slug, "?oid=").concat(offerId, "#popular_products")
  }, name) : ___EmotionJSX(Span, {
    fontWeight: "medium"
  }, name), ___EmotionJSX(Span, {
    color: "textTertiary",
    fontSize: "xs",
    lineHeight: "18px",
    p: "4px 6px",
    mb: "5px"
  }, "Marketplace Seller")), rating && ___EmotionJSX(Text, {
    m: 0,
    "data-testid": "sold-by-content",
    mb: 1
  }, ___EmotionJSX(Span, {
    textDecoration: "underline",
    pr: 2
  }, "Seller Rating", " ".concat(rating.percentage, "%")), ___EmotionJSX(Span, {
    fontSize: 8
  }, "\u2022"), ___EmotionJSX(Link, {
    pl: 2,
    textDecoration: "underline",
    color: "text",
    href: "/seller/".concat(slug, "?oid=").concat(offerId, "#popular_products")
  }, "See seller's other items")), isFBC && ___EmotionJSX(Text, {
    mt: 4,
    "data-testid": "delivered-by-catch"
  }, "Delivered by", ___EmotionJSX(IconCatchBrand, {
    width: "55px",
    height: "auto",
    title: "Catch logo",
    ml: 1
  }))));
};